export default function PricingSection() {
  const scrollToQRCode = () => {
    const element = document.getElementById('qrcode');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const features = [
    'Trang thương hiệu cá nhân chuyên nghiệp',
    'Thiết kế responsive trên mọi thiết bị',
    'Tối ưu SEO để dễ tìm kiếm trên Google',
    'Tích hợp mạng xã hội và liên hệ',
    'Giới thiệu dịch vụ/sản phẩm chi tiết',
    'Portfolio và thành tựu cá nhân',
    'Form liên hệ và đặt lịch hẹn',
    'Hỗ trợ kỹ thuật trong 30 ngày',
    'Hướng dẫn sử dụng và cập nhật',
    'Tên miền miễn phí trong 1 năm'
  ];

  return (
    <section id="pricing" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-amber-100 rounded-full mb-6">
            <i className="ri-price-tag-3-line text-lg text-amber-600"></i>
            <span className="text-sm font-semibold text-amber-700">Ưu Đãi Đặc Biệt</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Bảng Giá Ưu Đãi
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Cơ hội vàng để sở hữu trang thương hiệu cá nhân chuyên nghiệp với mức giá không thể tốt hơn
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 z-10">
              <div className="px-6 py-2.5 bg-gradient-to-r from-rose-500 to-rose-600 text-white text-sm font-bold rounded-full shadow-lg">
                🔥 TIẾT KIỆM 86% - CHỈ HÔM NAY
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-12 border-4 border-teal-500 shadow-2xl">
              <div className="text-center mb-10">
                <h3 className="text-3xl font-bold text-white mb-4">
                  Gói Thương Hiệu Cá Nhân
                </h3>
                <div className="flex items-center justify-center gap-4 mb-6">
                  <div className="text-gray-400 line-through text-2xl">500.000đ</div>
                  <div className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-amber-400">
                    70.000đ
                  </div>
                </div>
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-teal-500/20 rounded-full border border-teal-400/30">
                  <i className="ri-time-line text-teal-400"></i>
                  <span className="text-teal-300 text-sm font-semibold">Ưu đãi có thời hạn</span>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4 mb-10">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center bg-teal-500 rounded-full flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-sm text-white"></i>
                    </div>
                    <span className="text-white/90">{feature}</span>
                  </div>
                ))}
              </div>

              <button
                onClick={scrollToQRCode}
                className="whitespace-nowrap w-full py-5 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-xl font-bold rounded-xl hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-2xl hover:shadow-teal-500/50 transform hover:scale-105 cursor-pointer"
              >
                Đăng Ký Ngay - Chỉ 70.000đ
              </button>

              <p className="text-center text-white/60 text-sm mt-6">
                💳 Thanh toán an toàn - Hoàn tiền 100% nếu không hài lòng
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="text-center p-6 bg-gray-50 rounded-2xl">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-teal-600"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Bảo Hành 30 Ngày</h4>
              <p className="text-sm text-gray-600">Hỗ trợ kỹ thuật miễn phí</p>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-2xl">
              <div className="w-14 h-14 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-amber-600"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Tư Vấn Miễn Phí</h4>
              <p className="text-sm text-gray-600">Hỗ trợ 24/7 qua Zalo</p>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-2xl">
              <div className="w-14 h-14 flex items-center justify-center bg-rose-100 rounded-full mx-auto mb-4">
                <i className="ri-rocket-line text-2xl text-rose-600"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Giao Hàng Nhanh</h4>
              <p className="text-sm text-gray-600">Hoàn thành trong 3-5 ngày</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}